import { avoidSpecialRoadFlags, avoidSpecialRoadFlagsEnum } from "helpers/enums";

type RouteOptionsWithSeasonalRestrictions = {
    avoidSpecialRoadFlags?: number | null;
};

const enabledValues = ["1", "true", "yes", "on"];

export const isRegionDryingPeriodsEnabledForClients = enabledValues.includes(
    String(process.env.REGION_DRYING_PERIODS_FOR_CLIENTS_ENABLED).toLowerCase(),
);

export const seasonalRestrictionsFlagValue =
    avoidSpecialRoadFlags.find((flag) => flag.value === avoidSpecialRoadFlagsEnum.Cond)?.intValue ?? 4;

export const getClientAvoidSpecialRoadFlags = <T extends { value: string }>(flags: T[]): T[] =>
    isRegionDryingPeriodsEnabledForClients
        ? flags
        : flags.filter((flag) => flag.value !== avoidSpecialRoadFlagsEnum.Cond);

export const routeOptionsWithoutSeasonalRestrictions = <T extends RouteOptionsWithSeasonalRestrictions>(
    routeOptions: T,
): T => ({
    ...routeOptions,
    avoidSpecialRoadFlags: ((routeOptions.avoidSpecialRoadFlags ?? 0) &
        ~seasonalRestrictionsFlagValue) as T["avoidSpecialRoadFlags"],
});

export const getClientRouteOptions = <T extends RouteOptionsWithSeasonalRestrictions | null | undefined>(
    routeOptions: T,
): T => {
    if (!routeOptions || isRegionDryingPeriodsEnabledForClients) {
        return routeOptions;
    }

    return routeOptionsWithoutSeasonalRestrictions(routeOptions) as T;
};
